enum ReachableStopsFinderMode {
  Source = "source",
  Target = "target",
}

export default ReachableStopsFinderMode;
